import TransferYourBusinessDashboardWrapper from "components/lib/Shared/TransferYourBusinessDashboardWrapper";
import { Constants } from "config/constants";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getComments, resetCommentsSlice } from "state/slices/comment";
import { getCompany, reset } from "state/slices/company";
import {
  getReviewers,
  resetReviewersTableSlice,
} from "state/slices/tables/reviewersTable";
import { setCookie } from "utils/cookie";
import TransferYourBusinessReviewTab from "../components/TransferYourBusinessReviewTab";

const navigation = [{ id: "applicationReview", name: "Application Review" }];

const TransferYourBusinessReview = () => {
  const { companyId } = useParams();
  const [currentSectionIndex, setCurrentSectionIndex] = useState(0);
  const [selectedTab, setSelectedTab] = useState(navigation[0]);
  const currentUser = useSelector((state) => state.userSlice);
  const { getCompanyStatus } = useSelector((state) => state.companySlice);

  const role = Cookies.get("role");

  const handleBackBtn = () => {
    if (currentSectionIndex - 1 >= 0)
      setCurrentSectionIndex(currentSectionIndex - 1);
  };

  const handleNextBtn = () => {
    setCurrentSectionIndex(currentSectionIndex + 1);
  };

  useEffect(() => {
    const tempSelectedTab = navigation[currentSectionIndex];
    if (tempSelectedTab) setSelectedTab(tempSelectedTab);
  }, [navigation, currentSectionIndex]);

  const dispatch = useDispatch();

  useEffect(() => {
    if (companyId && currentUser._id) {
      dispatch(getCompany({ id: companyId }));
      dispatch(getComments({ companyId, createdBy: currentUser._id }));
      dispatch(getReviewers({ companyId }));
    }
    return () => {
      setCookie("role", Constants.COOKIE_ROLES.APPLICANT);
      dispatch(reset());
      dispatch(resetCommentsSlice());
      dispatch(resetReviewersTableSlice());
    };
  }, [companyId, currentUser._id]);

  return (
    <TransferYourBusinessDashboardWrapper>
      <TransferYourBusinessReviewTab
        handleBackBtn={handleBackBtn}
        handleNextBtn={handleNextBtn}
      />
    </TransferYourBusinessDashboardWrapper>
  );
};

export default TransferYourBusinessReview;
